import { render, staticRenderFns } from "./DesignButtonStyleDeleteModal.vue?vue&type=template&id=2b8d4416&scoped=true&"
import script from "./DesignButtonStyleDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./DesignButtonStyleDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d4416",
  null
  
)

export default component.exports